/* eslint-disable max-lines */
// TODO - maybe those values can be calcuated based on real rendering as if someone will define large padding etc it may not work
const VISIBLE_BACKLOG_HEIGHT = 100
const COMMANDBAR_DEFAULT_HEIGHT = 60
const VIDEO_BUTTON_DEFAULT_HEIGHT = 80

export const RESERVED_SPACE_WITH_VIDEO_BUTTON = VISIBLE_BACKLOG_HEIGHT + COMMANDBAR_DEFAULT_HEIGHT + VIDEO_BUTTON_DEFAULT_HEIGHT
export const RESERVED_SPACE_WITHOUT_VIDEO_BUTTON = VISIBLE_BACKLOG_HEIGHT + COMMANDBAR_DEFAULT_HEIGHT

const COMMANDBAR_ON_VIDEO_DEFAULT_MAX_HEIGHT = 100

/* eslint-disable sort-keys */
export const pickerWrapper = {
    variants: {
        theme: {
            dark: {'em-emoji-picker': {'--rgb-background': '37, 47, 56'}},
            light: {},
        },
    },
}

export const silencedMessages = {
    alignItems: 'center',
    color: '$error',
    display: 'flex',
    padding: '10px',
    svg: {
        marginRight: '5px',
        width: '20px',
    },
}


export const sendViewWrapper = {
    'backgroundColor': '$chatCommandBar',
    'borderWidth': '$chatCommandBar',
    'borderStyle': '$chatCommandBar',
    'borderColor': '$chatCommandBarBorder',
    'borderRadius': '$chatCommandBar',
    'flex': 'none',
    'margin': '0 0.6rem 0.6rem 0.6rem',
    '.tabContainer': {
        'boxShadow': '$chatCommandBarTabContainer',
        'padding': '0 0.4rem',
        '.tabs': {
            'alignItems': 'center',
            'overflowX': 'hidden',
            '.tab': {
                'background': 'transparent',
                'border': '0',
                'borderBottom': '1px solid $chatCommandBarTabBorder',
                'borderRadius': '0',
                'padding': '0.6rem 0.8rem',
                'color': '$chatCommandBarTabText',
                'whiteSpace': 'nowrap',
                '&.selected': {
                    borderColor: '$chatCommandBarTabSelectedBorder',
                    color: '$chatCommandBarTabSelectedText',
                },
                '.count': {
                    alignItems: 'center',
                    border: '2px solid $chatCommandBarCountBorder',
                    borderRadius: '0.9rem',
                    color: '$chatCommandBarCountText',
                    display: 'inline-flex',
                    fontSize: '0.7rem',
                    fontWeight: 600,
                    height: '0.9rem',
                    justifyContent: 'center',
                    marginLeft: '0.4rem',
                    width: '0.9rem',
                },
                '&:hover': {color: '$chatCommandBarTabTextHover'},
                '&:focus-visible': {
                    boxShadow: '$chatCommandBarTabFocus',
                    outline: 'none',
                },
            },
            '.status': {flex: 'none'},
        },
    },
    '.cannedMessages, .notes, .tags': {
        'borderBottom': '1px solid $chatCommandBarCannedMessagesBorder',
        'display': 'none',
        '&.open': {display: 'block'},
    },
    '.sendWrapper': {
        'border': '0',
        'padding': '0',
        '.growWrap': {
            'display': 'grid',
            'maxHeight': '8rem',
            'overflowY': 'hidden',
            'wordBreak': 'break-word',
            '&::after': {
                content: 'attr(data-replicated-value) ""',
                visibility: 'hidden',
                whiteSpace: 'pre-wrap',
            },
            '& > textarea': {
                'background': 'transparent',
                'boxSizing': 'border-box',
                'border': 'none',
                'color': '$chatCommandBarTextareaText',
                'margin': '0',
                'maxHeight': '8rem',
                'overflowY': 'auto',
                'padding': '12px 12px 0 12px',
                'resize': 'none',
                '&:focus': {outline: 'none'},
                '&::placeholder': {color: '$chatCommandBarTextareaPlaceholder'},
            },
            '& > textarea, &::after': {
                font: 'inherit',
                gridArea: '1 / 1 / 2 / 2',
                padding: '12px 12px 0 12px',
            },
        },
    },
    'variants': {
        isEmbedQueueChannel: {
            true: {
                'position': 'relative',
                '.sendWrapper': {
                    '.growWrap': {
                        'maxHeight': `min($chatTextareaMaxHeight, calc(100vh - ${RESERVED_SPACE_WITH_VIDEO_BUTTON}px))`, // to fit hero with video button + commandbar + spacing
                        'minHeight': '48px',
                        '& > textarea': {
                            padding: '12px',
                            maxHeight: `min($chatTextareaMaxHeight, calc(100vh - ${RESERVED_SPACE_WITH_VIDEO_BUTTON}px))`,
                            minHeight: '48px',
                        },
                        '& > textarea, &::after': {padding: '12px'},
                    },
                },
            },
        },
        isVideoChannel: {true: {}},
        isEmbedContainerWithHeader: {true: {}},
        isActiveVideoChannel: {true: {}},
    },
    'compoundVariants': [
        {
            isEmbedQueueChannel: true,
            isVideoChannel: false,
            isEmbedContainerWithHeader: false,
            css: {
                '.sendWrapper': {
                    '.growWrap': {
                        'maxHeight': `min($chatTextareaMaxHeight, calc(100vh - ${RESERVED_SPACE_WITHOUT_VIDEO_BUTTON}px))`, // to fit commandbar + spacing
                        '& > textarea': {maxHeight: `min($chatTextareaMaxHeight, calc(100vh - ${RESERVED_SPACE_WITHOUT_VIDEO_BUTTON}px))`},
                    },
                },
            },
        },
        {
            isEmbedQueueChannel: true,
            isVideoChannel: true,
            isEmbedContainerWithHeader: true,
            css: {
                '.sendWrapper': {
                    '.growWrap': {
                        'maxHeight': `min($chatTextareaMaxHeight, calc(100vh - ${RESERVED_SPACE_WITH_VIDEO_BUTTON}px - $$headerHeight))`, // to fit commandbar + spacing + header
                        '& > textarea': {maxHeight: `min($chatTextareaMaxHeight, calc(100vh - ${RESERVED_SPACE_WITH_VIDEO_BUTTON}px - $$headerHeight))`},
                    },
                },
            },
        },
        {
            isEmbedQueueChannel: true,
            isVideoChannel: false,
            isEmbedContainerWithHeader: true,
            css: {
                '.sendWrapper': {
                    '.growWrap': {
                        'maxHeight': `min($chatTextareaMaxHeight, calc(100vh - ${RESERVED_SPACE_WITHOUT_VIDEO_BUTTON}px - $$headerHeight))`, // to fit commandbar + spacing + header
                        '& > textarea': {maxHeight: `min($chatTextareaMaxHeight, calc(100vh - ${RESERVED_SPACE_WITHOUT_VIDEO_BUTTON}px - $$headerHeight))`},
                    },
                },
            },
        },
        {
            isEmbedQueueChannel: true,
            isVideoChannel: true,
            isActiveVideoChannel: true,
            css: {
                '.sendWrapper': {
                    '.growWrap': {
                        'maxHeight': `min($chatTextareaMaxHeight, ${COMMANDBAR_ON_VIDEO_DEFAULT_MAX_HEIGHT}px)`,
                        '& > textarea': {maxHeight: `min($chatTextareaMaxHeight, ${COMMANDBAR_ON_VIDEO_DEFAULT_MAX_HEIGHT}px)`},
                    },
                },
            },
        },
    ],
}

export const form = {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    justifyContent: 'flex-start',
    variants: {
        isEmbedQueueChannel: {
            true: {
                'flexDirection': 'row',
                '> fieldset:first-child': {
                    'width': '100%',
                    '> div': {height: '100%'},
                },
            },
        },
        multilineEnabled: {true: {}},
    },
    compoundVariants: [
        {
            isEmbedQueueChannel: true,
            multilineEnabled: true,
            css: {
                'flexDirection': 'column',
                '> fieldset:first-child': {width: 'auto'},

            },
        },
        {
            isEmbedQueueChannel: true,
            multilineEnabled: false,
            css: {
                '> fieldset': {padding: '8px'},
                '> fieldset:first-child': {width: '100%'},
            },
        },
    ],
}

export const textarea = {variants: {isEmbedQueueChannel: {true: {}}}}

export const sendIcon = {
    display: 'flex',
    alignItems: 'center',
}

export const messageBlocked = {
    backgroundColor: '$toastBackgroundError',
    color: '$toastTextError',
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    svg: {
        marginRight: '5px',
        width: '20px',
    },
    position: 'absolute',
    bottom: 'calc(100% + 10px)',
    left: 0,
    right: 0,
    boxSizing: 'border-box',
    margin: '0 -0.6rem',
}
